/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetUserGachaEnhancementResponse } from '../../models/set-user-gacha-enhancement-response';
import { UserServiceSetUserGachaEnhancement2Request } from '../../models/user-service-set-user-gacha-enhancement-2-request';

export interface UserServiceSetUserGachaEnhancement2$Params {
  userUuid: string;
  gachaInstanceId: string;
      body: UserServiceSetUserGachaEnhancement2Request
}

export function userServiceSetUserGachaEnhancement2(http: HttpClient, rootUrl: string, params: UserServiceSetUserGachaEnhancement2$Params, context?: HttpContext): Observable<StrictHttpResponse<SetUserGachaEnhancementResponse>> {
  const rb = new RequestBuilder(rootUrl, userServiceSetUserGachaEnhancement2.PATH, 'post');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.path('gachaInstanceId', params.gachaInstanceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SetUserGachaEnhancementResponse>;
    })
  );
}

userServiceSetUserGachaEnhancement2.PATH = '/api/v3/gateway/user/{userUuid}/gacha/instance/{gachaInstanceId}/enhancement';
